// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-container{display:flex;flex-direction:row;align-items:baseline}.search-container .customInput{padding-bottom:unset}.search-container .btn-custom{margin:0px 10px;padding:5px 15px;width:70px;height:50px}.search-container .btn-exit{background-color:#027aff;color:white}\n", ""]);
// Exports
module.exports = exports;
